import { render } from "./P1.vue?vue&type=template&id=7f7a1058&scoped=true"
import script from "./P1.vue?vue&type=script&lang=js"
export * from "./P1.vue?vue&type=script&lang=js"

import "./P1.vue?vue&type=style&index=0&id=7f7a1058&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f7a1058"

export default script